<template>
    <b-container>
        <b-row>
            <b-col>
                <b-card-group>
                    <b-card class="p-4">
                        <h1 class="mb-3">Авторизация</h1>
                        <form @submit.prevent="login()">
                            <div class="input-group mb-3">
                                <span class="input-group-addon"><i class="icon-user"></i></span>
                                <input type="text" class="form-control" placeholder="Имя пользователя" v-model="credentials.username">
                            </div>
                            <div class="input-group mb-4">
                                <span class="input-group-addon"><i class="icon-lock"></i></span>
                                <input type="password" class="form-control" placeholder="Пароль" v-model="credentials.password">
                            </div>
                            <div class="row">
                                <b-col cols="6">
                                    <b-button ref="AuthLoginBtn" type="submit" variant="primary" class="px-4" :disabled="disabled">Вход</b-button>
                                </b-col>
                                <b-col cols="6" class="text-right">
                                    <b-link :to="{name: 'AuthRemindPassword'}" class="btn btn-link px-0">Забыли пароль?</b-link>
                                </b-col>
                            </div>
                        </form>
                        <b-modal title="Ошибка авторизации" v-model="isError" :ok-only="true" class="modal-danger" >
                            <p clas="my-4">{{ errorMessage }}</p>
                        </b-modal>
                    </b-card>
                    <b-card bg-variant="primary" class="text-center">
                        <h3 class="mt-3 mb-3">Регистрация</h3>
                        <p class="pl-1 pr-1">Если Вы&nbsp;уже являетесь клиентом сервисов компании &laquo;Professional Group&raquo;, то&nbsp;Вам не&nbsp;нужно проходить процедуру регистраци&nbsp;&mdash; Вы&nbsp;можете авторизоваться под своим логином/паролем из&nbsp;этих сервисов.</p>
                        <b-link :to="{name: 'AuthRegistration'}" router-tag="button" class="btn btn-primary active mt-3">Зарегистрироваться</b-link>
                    </b-card>
                </b-card-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="text-center">
                <b-link :to="{name: 'Frontend'}" class="btn btn-primary">На главную</b-link>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import qs from 'qs'

    export default {
        name: 'Login',
        data () {
            return {
                credentials: {
                    username: '',
                    password: ''
                },
                isError: false,
                isChecking: false,
                errorCode: null
            }
        },
        computed: {
            disabled () {
                return (this.isChecking || !this.credentials.username || !this.credentials.password)
            },
            errorMessage () {
                return this.errorCode
            }
        },
        mounted () {
            // console.log(this.$auth.redirect())
        },
        methods: {
            login () {
                let redirect = this.$auth.redirect()

                this.isChecking = true

                // this.$refs['AuthLoginBtn'].classList.add('')

                this.$auth.login({
                    data: qs.stringify(this.credentials),
                    redirect: {name: redirect ? redirect.from.name : 'Dashboard'},
                    fetchUser: true,
                    success () {
                        this.isChecking = false
                        this.$router.push({name: redirect ? redirect.from.name : 'Dashboard'})
                    },
                    error (res) {
                        this.isChecking = false
                        this.isError = true
                        this.errorCode = res.response.data.message
                        this.credentials.password = ''
                    }
                })
            }
        }
    }
</script>

<style scope>

</style>


// WEBPACK FOOTER //
// Login.vue?d2adf748